/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PresetCreateVisibility = typeof PresetCreateVisibility[keyof typeof PresetCreateVisibility];


export const PresetCreateVisibility = {
  public: 'public',
  private: 'private',
} as const;
